import React from "react";

export function toEmbed(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    const host = u.hostname.replace("www.", "");
    if (host === "youtube.com" || host === "m.youtube.com") {
      const id = u.searchParams.get("v");
      if (id) return { type: "iframe", src: `https://www.youtube.com/embed/${id}` };
    }
    if (host === "youtu.be") {
      const id = u.pathname.slice(1);
      if (id) return { type: "iframe", src: `https://www.youtube.com/embed/${id}` };
    }
    if (host === "vimeo.com") {
      const id = u.pathname.split("/").filter(Boolean)[0];
      if (id) return { type: "iframe", src: `https://player.vimeo.com/video/${id}` };
    }
    if (/\.(mp4|webm|ogg)$/i.test(u.pathname)) return { type: "video", src: url };
    return { type: "iframe", src: url };
  } catch {
    return null;
  }
}

export function VideoEmbed({ url }) {
  const embed = toEmbed(url);
  if (!embed) return null;
  return (
    <div className="rounded-md overflow-hidden bg-black" data-testid="material-video-embed">
      <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
        {embed.type === "video" ? (
          <video src={embed.src} controls className="absolute inset-0 w-full h-full" />
        ) : (
          <iframe
            src={embed.src}
            title="Video materi"
            className="absolute inset-0 w-full h-full"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        )}
      </div>
    </div>
  );
}

export function PdfEmbed({ url }) {
  if (!url) return null;
  return (
    <div className="rounded-md overflow-hidden border border-border bg-muted" data-testid="material-pdf-embed">
      <object data={url} type="application/pdf" className="w-full" style={{ height: "70vh" }}>
        <iframe src={url} title="Dokumen PDF" className="w-full" style={{ height: "70vh" }} frameBorder="0" />
      </object>
    </div>
  );
}
